import nullThrows from "@hypertune/sdk/src/shared/helpers/nullThrows";

export default function toInt(string: string | undefined): number {
  const int = parseInt(nullThrows(string, "[toInt] null string"), 10);
  if (Number.isNaN(int)) {
    throw new Error("[toInt] NaN");
  }
  return int;
}
